import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Engineering.css";

function Engineering() {
const [userGrade, setUserGrade] = useState(null); // Stores detected grade

// Simulated function to get the user’s age and convert it to grade
useEffect(() => {
  const userAge = parseInt(localStorage.getItem("userAge"), 10); // Simulated stored age
  if (userAge && userAge >= 6 && userAge <= 18) {
    setUserGrade(userAge - 5); // Grade = Age - 5 (Assumption: Grade 1 starts at Age 6)
  }
}, []);

// Generates the list of grades (If userGrade exists, show only that grade)
const gradeList = userGrade
  ? [<Link key={userGrade} to={`/Engineering/grade${userGrade}`} className="Engineering-grade-card">Grade {userGrade}</Link>]
  : [...Array(12)].map((_, index) => (
      <Link key={index + 1} to={`/Engineering/grade${index + 1}`} className="Engineering-grade-card">
        Grade {index + 1}
      </Link>
    ));

return (
  <div className="play2learn-Engineering">
    <h1 className="Engineering-title">Engineering Lessons</h1>
    <p className="Engineering-description">
      {userGrade ? `Showing content for Grade ${userGrade}` : "Select a grade to start learning:"}
    </p>

    {/* Grade Selection */}
    <div className="Engineering-grade-container">
      {gradeList}
    </div>
  </div>
);
}

export default Engineering;